import { Component, Injector } from '@angular/core';
import { MobileAppServices, MobileAppWrapper } from './components/mobile/mobile.app.wrapper.component';
import { RouterOutlet } from '@angular/router';
import { ActionButtonComponent } from './components/nav-bar/action-button.component';
import { IconComponent } from './components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { AppNotificationBase } from 'globals/store/app.data';
import { appsFeature } from './store/app.era';
import { mobileAppFeature } from './components/mobile/mobile-store/mobile.app.era';


@Component({
    selector: 'mobile-root',
    template: `
<div *ngIf="!!shownNotification" class="notification">
  <icon [icon]="'close'" (click)="closeNotification()"></icon>
  <h3 *ngIf="!!shownNotification.title" class="title">{{ shownNotification.title }}</h3>
  <div *ngIf="!!shownNotification.message" class="message">{{ shownNotification.message }}</div>
  <action-button *ngIf="!!shownNotification.linkType" class="link" (click)="openNotificationLink()">OPEN</action-button> 
</div>
<router-outlet></router-outlet>    
`,
    styles: [`
  :host { display: relative; height: 100vh; width: 100vw; }
  .notification { position: absolute; background: var(--contentbg); height: calc(100vh - 10vw); width: calc(100vw - 10vw); padding: 5vw; margin: 5vw; z-index: 100; border-radius: 5vw; }
  .message, .link { margin-top: 5vw; }
  .close { position: absolute; right: 5vw; }
`],
    standalone: true,
    imports: [RouterOutlet, ActionButtonComponent, IconComponent, CommonModule],
})
export class MobileAppComponent extends MobileAppWrapper<MobileAppComponent> {
  shownNotification: AppNotificationBase
  constructor(injector: Injector) {
    super()
    MobileAppServices.initialize(injector)
    this.store.select(mobileAppFeature.selectShownNotification).subscribe(notification => {
      this.shownNotification = notification
    })
  }

  openNotificationLink() {
    this.mobileAppService.openNotificationLink(this.shownNotification)
  }

  closeNotification() {
    this.mobileAppService.closeNotification(this.shownNotification)
  }

}
